import React from 'react'

const Logo: React.FC<React.SVGAttributes<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 116.87 51.74" {...props}>
    <defs></defs>
    <g>
      <path
        d="M8.46 10.44 4.57 10.44 4.57 39.62 0 39.62 0 8.35 8.46 8.35 8.46 10.44Z"
        fill="#ffffff"
      />
      <path
        d="M9.25 31.1 9.25 16.58C9.25 11.25 12.18 7.95 16.95 7.95 21.72 7.95 24.68 11.28 24.68 16.58L24.68 23.91 13.94 23.91 13.94 32.99C13.94 35.98 15.12 37.9 16.96 37.9 18.8 37.9 20.01 35.98 20.01 32.99L20.01 29.83 24.69 29.83 24.69 30.93C24.69 36.51 21.73 40.01 16.96 40.01 12.19 40.01 9.26 36.6 9.26 31.1ZM19.99 22.11 19.99 14.69C19.99 11.87 18.81 10.07 16.94 10.07 15.07 10.07 13.92 11.9 13.92 14.69L13.92 22.11 19.98 22.11Z"
        fill="#ffffff"
      />
      <path
        d="M27.23 43.28 27.23 43.22 31.8 43.22 31.8 45.17C31.8 47.9 32.93 49.65 34.9 49.65 36.65 49.65 37.83 48.24 37.83 45.65 37.83 35.64 26.89 33.67 26.89 19.74L26.89 19.71C26.89 12.75 29.94 8.35 34.76 8.35L50.24 8.35 50.24 39.62 45.67 39.62 45.67 10.44 39.72 10.44C41.52 12.36 42.54 15.54 42.54 19.66 42.54 26.45 39.86 30.68 35.38 31.02 37.69 34.49 42.43 38.35 42.43 44.44 42.43 48.95 39.5 51.74 34.99 51.74 30.23 51.74 27.24 48.64 27.24 43.28ZM34.73 29.3C36.62 29.3 37.75 27.07 37.75 23.44L37.75 15.83C37.75 12.36 36.62 10.19 34.73 10.19 32.84 10.19 31.68 12.36 31.68 15.83L31.68 23.44C31.68 27.08 32.84 29.3 34.73 29.3Z"
        fill="#ffffff"
      />
      <path
        d="M52.78 30.91C52.78 20.84 63.3 19.49 63.3 12.98 63.3 11.2 62.26 10.05 60.59 10.05 58.5 10.05 57.15 11.97 57.15 15.89L52.64 15.89C52.61 11.24 55.74 7.94 60.59 7.94 64.93 7.94 67.75 10.59 67.75 14.96L67.75 39.63 61.89 39.63C56.25 39.63 52.78 36.3 52.78 30.92ZM62.05 37.67 63.29 37.67 63.29 16.13C62.16 20.27 57.31 23.32 57.31 30.48 57.31 34.57 58.92 37.67 62.05 37.67Z"
        fill="#ffffff"
      />
      <path
        d="M19.48 5.82 21.92 0 17.38 0 14.99 5.82 19.48 5.82Z"
        fill="#ffffff"
      />
      <path
        d="M47.96 0C49.6 0 50.89 1.33 50.89 2.93 50.89 4.53 49.56 5.86 47.96 5.86 46.36 5.86 45.06 4.56 45.06 2.93 45.06 1.3 46.36 0 47.96 0Z"
        fill="#ffffff"
      />
    </g>
    <g>
      <path
        d="M79.42 25.12 79.42 22.82C79.42 21.46 80.29 20.75 81.58 20.75 82.87 20.75 83.75 21.46 83.75 22.88L83.75 22.92 82.96 22.92 82.96 22.68C82.96 21.68 82.41 21.16 81.58 21.16 80.75 21.16 80.2 21.68 80.2 22.68L80.2 25.26C80.2 26.26 80.75 26.79 81.58 26.79 82.41 26.79 82.96 26.26 82.96 25.26L82.96 25 83.75 25 83.75 25.04C83.75 26.49 82.88 27.19 81.58 27.19 80.28 27.19 79.42 26.49 79.42 25.12Z"
        fill="#ffffff"
      />
      <path
        d="M87.87 20.75C89.13 20.75 89.98 21.44 89.98 22.77L89.98 27.08 89.19 27.08 89.19 24.23 86.55 24.23 86.55 27.08 85.76 27.08 85.76 22.77C85.76 21.44 86.6 20.75 87.87 20.75ZM89.2 23.83 89.2 22.64C89.2 21.65 88.67 21.15 87.88 21.15 87.09 21.15 86.56 21.65 86.56 22.64L86.56 23.83 89.2 23.83Z"
        fill="#ffffff"
      />
      <path
        d="M94.52 20.85C95.67 20.85 96.4 21.49 96.4 22.52 96.4 23.55 95.67 24.22 94.52 24.22L92.96 24.22 92.96 27.08 92.19 27.08 92.19 20.85 94.52 20.85ZM94.33 23.82C95.12 23.82 95.6 23.3 95.6 22.52 95.6 21.74 95.11 21.24 94.33 21.24L92.96 21.24 92.96 23.82 94.33 23.82Z"
        fill="#ffffff"
      />
      <path
        d="M99.18 20.85 99.18 27.08 98.41 27.08 98.41 20.85 99.18 20.85Z"
        fill="#ffffff"
      />
      <path
        d="M102.78 21.25 101.01 21.25 101.01 20.85 105.31 20.85 105.31 21.25 103.55 21.25 103.55 27.08 102.78 27.08 102.78 21.25Z"
        fill="#ffffff"
      />
      <path
        d="M108.97 20.75C110.23 20.75 111.08 21.44 111.08 22.77L111.08 27.08 110.29 27.08 110.29 24.23 107.65 24.23 107.65 27.08 106.86 27.08 106.86 22.77C106.86 21.44 107.7 20.75 108.97 20.75ZM110.29 23.83 110.29 22.64C110.29 21.65 109.76 21.15 108.97 21.15 108.18 21.15 107.65 21.65 107.65 22.64L107.65 23.83 110.29 23.83Z"
        fill="#ffffff"
      />
      <path
        d="M113.29 20.85 114.06 20.85 114.06 26.68 116.88 26.68 116.88 27.08 113.29 27.08 113.29 20.85Z"
        fill="#ffffff"
      />
    </g>
  </svg>
)

export default Logo
